import React from 'react';
import {Range} from 'rc-slider';
import {connectRange} from 'react-instantsearch-dom';
import cx from 'classnames';

import {useOverlayThatClosesOnOutsideClick} from '../../hooks/useOverlayThatClosesOnOutsideClick';

import 'rc-slider/assets/index.css';
import './RangeSlider.scss';

export const RangeSlider = connectRange(
  ({
    currentRefinement,
    refine,
    min,
    max,
    name,
    side = 'right',
    unit = undefined,
  }) => {
    const { isOpen, toggle, containerRef } = useOverlayThatClosesOnOutsideClick(
      { containerRef, isOpen, close: toggle }
    );

    const { min: fromValue, max: toValue } = currentRefinement;
    const isInUse = fromValue !== min || toValue !== max;
    const formattedRange = unit
      ? `${unit}${fromValue} - ${unit}${toValue}`
      : `${fromValue} - ${toValue}`;

    return (
      <>
        <div
          className="range-selector flex flex-col w-full lg:flex-1 lg:mt-0"
          ref={containerRef}
        >
          <div
            className={cx(
              'flex-1 filter-btn rounded-sm',
              isOpen || isInUse ? 'filter-btn--gold' : ''
            )}
            onClick={toggle}
          >
            <span>{name}</span>
            <i
              className={cx('fas', isOpen ? 'fa-caret-up' : 'fa-caret-down')}
            />
          </div>
          {isOpen && (
            <div className={cx('overlay', `overlay--${side}`)}>
              <div className="flex flex-col">
                <div className="overlay-top">
                  <div className="flex flex-col text-sm leading-sm">
                    <span className="text-40">{name} Range Selected</span>
                    <span>{formattedRange}</span>
                  </div>
                  <div
                    onClick={() => {
                      refine({ min, max });
                    }}
                    className="simple-btn btn-ghost border border-30 text-sm font-normal"
                  >
                    Clear
                  </div>
                </div>
                <div className="overlay-body">
                  <Range
                    min={min}
                    max={max}
                    value={[fromValue, toValue]}
                    onChange={([newFromValue, newToValue]) => {
                      refine({ min: newFromValue, max: newToValue });
                    }}
                    pushable
                    trackStyle={[{ backgroundColor: '#f7b733' }]}
                    railStyle={{ backgroundColor: '#2b2b2b' }}
                    handleStyle={[
                      {
                        backgroundColor: '#f7b733',
                        borderColor: '#f7b733',
                        boxShadow: 'none',
                        width: 20,
                        height: 20,
                        marginTop: -8,
                      },
                      {
                        backgroundColor: '#f7b733',
                        borderColor: '#f7b733',
                        boxShadow: 'none',
                        width: 20,
                        height: 20,
                        marginTop: -8,
                      },
                    ]}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </>
    );
  }
);
